import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { AppState } from '../index'
import {
  ApplicationModal,
  setAccountModal,
  setOpenModal,
  setTokenDecimals,
  TokenDecimals,
  setUIMode,
  SwapLimit,
  // setGlobalAnnouncement,
} from './reducer'

import { useActiveWeb3React } from '../../hooks/web3'
import { CabitalAssetsConfigRes } from 'services/types/User'
import { NetworkModel, TokenModel } from 'services/types/Application'

export function useBlockNumber(): number | undefined {
  const { chainId } = useActiveWeb3React()

  return useAppSelector((state: AppState) => state.application.blockNumber[chainId ?? -1])
}

export function useModalOpen(modal: ApplicationModal): boolean {
  const openModal = useAppSelector((state: AppState) => state.application.openModal)
  return openModal === modal
}

export function useCabitalAssetsConfig(): CabitalAssetsConfigRes {
  return useAppSelector((state: AppState) => state.application.assetsConfig)
}

export function useToggleModal(modal: ApplicationModal): () => void {
  const open = useModalOpen(modal)
  const dispatch = useAppDispatch()
  return useCallback(() => dispatch(setOpenModal(open ? null : modal)), [dispatch, modal, open])
}

export function useTokenDecimals(data: Array<TokenDecimals>) {
  const dispatch = useAppDispatch()
  return dispatch(setTokenDecimals(data))
}

export function useStakeComfirmationModalToggle(): () => void {
  return useToggleModal(ApplicationModal.STAKE_CONFIRMATION)
}

export function useConfirmOrderModalToggle(): () => void {
  return useToggleModal(ApplicationModal.CONFIRM_ORDER)
}

export function useInstantDepositToggle(): () => void {
  return useToggleModal(ApplicationModal.Instant_Deposit)
}

export function useConfirmModalToggle(): () => void {
  return useToggleModal(ApplicationModal.CONFIRM)
}

export function useCommonConfirmModalToggle(): () => void {
  return useToggleModal(ApplicationModal.COMMON_CONFIRM)
}

export function useNftFragmentModalToggle(): () => void {
  return useToggleModal(ApplicationModal.NFT_FRAGMENT_COMPOUND)
}
export function useCabitalModalToggle(): () => void {
  return useToggleModal(ApplicationModal.CABITAL)
}

export function useInsufficientBalanceModalToggle(): () => void {
  return useToggleModal(ApplicationModal.INSUFFICIENT_BALANCE)
}

export function useFASSModalToggle(): () => void {
  return useToggleModal(ApplicationModal.FASS_MODAL)
}
export function useWalletModalToggle(): () => void {
  return useToggleModal(ApplicationModal.WALLET)
}

export function useWalletModelInfo() {
  return useAppSelector((state: AppState) => state.application.walletModalInfo)
}

export function useUsdPrice() {
  return useAppSelector((state: AppState) => state.application.usdPrice)
}

export function useAccountModal() {
  return useAppSelector((state: AppState) => state.application.accountModal)
}

export function usePreviousUrl() {
  return useAppSelector((state: AppState) => state.application.previousUrl)
}

export function useUpdateAccountModal(data: string) {
  const dispatch = useAppDispatch()
  return dispatch(setAccountModal(data))
}

export function useUIMode() {
  return useAppSelector((state: AppState) => state.application.uiMode)
}

export function useUIModeToggle(): () => void {
  const uiMode = useUIMode()
  const dispatch = useAppDispatch()
  return useCallback(() => dispatch(setUIMode(uiMode === 'dark' ? 'light' : 'dark')), [dispatch, uiMode])
}

export function useGameMenus() {
  return useAppSelector((state: AppState) => state.application.gameMenus)
}

export function useTokenList(): Array<TokenModel> {
  return useAppSelector((state: AppState) => state.application.tokenList)
}

export function useHomePlayId() {
  return useAppSelector((state: AppState) => state.application.homePlayId)
}

export function useRewardConfig() {
  return useAppSelector((state: AppState) => state.application.rewardConfig)
}

export function useNetWorkList(): Array<NetworkModel> {
  return useAppSelector((state: AppState) => state.application.networkList)
}
// export function useGlobalAnnouncement() {
//   return useAppSelector((state: AppState) => state.application.globalAnnouncement)
// }

// export function useCloseGlobalAnnouncement() {
//   const dispatch = useAppDispatch()
//   return useCallback(() => dispatch(setGlobalAnnouncement(false)), [dispatch])
// }

export function useSwapLimit(): SwapLimit {
  return useAppSelector((state: AppState) => state.application.swapLimit)
}

export function useFaasParams() {
  return useAppSelector((state: AppState) => state.application.faasParams)
}
